import React from "react";

const SvgLegendParkingLot = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 15 20" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="LegendParkingLot_svg__a"
        d="M1126.778 351H1119v20h4.445v-6.667h3.333a6.672 6.672 0 0 0 6.667-6.666 6.672 6.672 0 0 0-6.667-6.667m.222 8.899h-3.555v-4.454H1127a2.231 2.231 0 0 1 2.222 2.227c0 1.225-1 2.227-2.222 2.227"
      />
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#LegendParkingLot_svg__a"
      transform="translate(-1119 -351)"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgLegendParkingLot svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/LegendParkingLot.js